import { render, staticRenderFns } from "./CreatOrderFourth.vue?vue&type=template&id=89429dc2"
import script from "./CreatOrderFourth.vue?vue&type=script&lang=js"
export * from "./CreatOrderFourth.vue?vue&type=script&lang=js"
import style0 from "./CreatOrderFourth.vue?vue&type=style&index=0&id=89429dc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports